import { Tooltip } from "@arco-design/web-react";
import { useTranslation } from "react-i18next";
import { GoogleAuthButton } from "../GoogleAuthButton";
import { MicrosoftLoginButton } from "../MicrosoftLoginButton";
import { GoogleRegisterButton } from "../GoogleRegisterButton";
import { MicrosoftRegisterButton } from "../MicrosoftRegisterButton";
import { LinkedInInIcon } from "./LinkedInInIcon";
import "./AuthSplitLayout.css";

type AuthSsoRowProps = {
  mode: "login" | "register";
  isMentor?: boolean;
  isGuest?: boolean;
  signupSource?: string;
  redirectPath?: string;
};

const LinkedInDisabledButton = () => {
  const { t } = useTranslation();
  return (
    <Tooltip content={t("login_page.linkedin_coming_soon")}>
      <span
        className="auth-sso-btn auth-sso-btn--disabled auth-sso-btn--linkedin"
        role="img"
        aria-label="LinkedIn (coming soon)"
      >
        <LinkedInInIcon />
      </span>
    </Tooltip>
  );
};

/** Compact circular SSO buttons matching Figma login/register designs. */
export const AuthSsoRow = ({
  mode,
  isMentor = false,
  isGuest = false,
  signupSource,
  redirectPath,
}: AuthSsoRowProps) => {
  const { t } = useTranslation();

  const buttons =
    mode === "login" ? (
      <>
        <MicrosoftLoginButton variant="icon" />
        <GoogleAuthButton variant="icon" />
        <LinkedInDisabledButton />
      </>
    ) : (
      <>
        <MicrosoftRegisterButton
          isMentor={isMentor}
          isGuest={isGuest}
          signupSource={signupSource}
          redirectPath={redirectPath}
          variant="icon"
        />
        <GoogleRegisterButton
          isMentor={isMentor}
          isGuest={isGuest}
          signupSource={signupSource}
          redirectPath={redirectPath}
          variant="icon"
        />
        <LinkedInDisabledButton />
      </>
    );

  return (
    <div className="auth-sso-row">
      <p className="auth-sso-row__label">
        {t(mode === "login" ? "login_page.sso_label" : "register_page.sso_label")}
      </p>
      <div className="auth-sso-row__buttons">{buttons}</div>
    </div>
  );
};
